import { render, staticRenderFns } from "./InvoiceItems.vue?vue&type=template&id=2f2f81de"
import script from "./InvoiceItems.vue?vue&type=script&lang=js"
export * from "./InvoiceItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports